import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { Link } from "react-router-dom";

/*
 * Learn With Us — community education programs.
 * HONESTY: status badges reflect reality — nothing is claimed as
 * "enrolling now" until it truly is. Interest-list CTAs route to contact.
 */

const programs = [
  {
    icon: "🌱",
    name: "Tech Basics",
    status: "Piloting soon",
    color: "#12bfbe",
    audience: "For anyone uncomfortable with computers",
    desc: "A judgment-free starting point: using a mouse and keyboard, email, browsing safely, video calls with family, and not being afraid of 'breaking something'.",
  },
  {
    icon: "🛡️",
    name: "Cyber Safe",
    status: "Piloting soon",
    color: "#9198e5",
    audience: "For everyone — no experience needed",
    desc: "Passwords that actually protect you, phishing recognition, multi-factor authentication, scam defense, and protecting your personal information — in plain language.",
  },
  {
    icon: "🔧",
    name: "Inside a Computer",
    status: "In development",
    color: "#1e3a8a",
    audience: "Hands-on learners",
    desc: "Our signature hands-on class: participants take apart a real computer, learn every part, then rebuild it — and lose the fear of the machine forever.",
  },
  {
    icon: "🌐",
    name: "Build Your First Website",
    status: "In development",
    color: "#36395a",
    audience: "Teenagers and adults",
    desc: "From blank page to a live website you made yourself — HTML, CSS, and the confidence to keep going. No experience required.",
  },
  {
    icon: "🦈",
    name: "AI Lab",
    status: "Powered by LAMNA",
    color: "#12bfbe",
    audience: "Curious minds of all ages",
    desc: "What AI actually is (beyond the hype), how to use it responsibly, and hands-on experiments with the AI infrastructure we're building in-house. Our most distinctive class — taught on our own LAMNA platform.",
    featured: true,
  },
];

const Programs = () => {
  useDocTitle("ZelT | Learn With Us");

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 max-w-6xl mx-auto">
          <div className="text-center mb-12" data-aos="zoom-in">
            <h1 className="text-4xl md:text-5xl font-extrabold text-blue-900 mb-4">
              Learn With Us
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Free community classes from ZelTechnology — taught in plain
              language, at your pace, with zero judgment. We're launching
              these programs step by step; tell us which one you want first
              and we'll prioritize it.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-14">
            {programs.map((p) => (
              <div
                key={p.name}
                className={`relative bg-gray-50 rounded-2xl p-6 shadow-lg border-t-4 flex flex-col ${
                  p.featured ? "ring-2 ring-teal-400" : ""
                }`}
                style={{ borderTopColor: p.color }}
                data-aos="fade-up"
              >
                {p.featured && (
                  <span className="absolute -top-3 right-4 bg-teal-400 text-blue-900 text-xs font-bold px-3 py-1 rounded-full">
                    🦈 OUR SIGNATURE
                  </span>
                )}
                <span className="text-4xl mb-3">{p.icon}</span>
                <h2 className="text-xl font-extrabold text-blue-900 mb-1">
                  {p.name}
                </h2>
                <p className="text-gray-500 text-xs font-semibold mb-3">
                  {p.audience}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed flex-1">
                  {p.desc}
                </p>
                <span
                  className="mt-4 inline-block self-start px-3 py-1 rounded-full text-xs font-bold"
                  style={{ backgroundColor: `${p.color}22`, color: p.color }}
                >
                  {p.status}
                </span>
              </div>
            ))}
          </div>

          <div
            className="rounded-2xl p-8 text-white text-center shadow-xl"
            style={{ background: "linear-gradient(90deg, #36395a, #1e3a8a)" }}
            data-aos="fade-up"
          >
            <h2 className="text-2xl font-extrabold mb-2">
              Which class should launch first?
            </h2>
            <p className="text-gray-300 mb-6 max-w-xl mx-auto">
              We're building the schedule around community demand. Tell us
              what you (or someone you love) needs most.
            </p>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 rounded-xl bg-teal-400 text-blue-900 font-bold hover:bg-teal-300 transition"
            >
              Join the Interest List
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Programs;
